import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import './main-menu-component.scss';
import { Navbar, Nav, NavDropdown, Form } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import orbLogo from '../../assets/images/logo-orb-explorer.png';
import WalletMenu from '../../controls/wallet-menu/wallet-menu-component';

export default function MainMenuComponent(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();

  const [addressOrTxId, setAddressOrTxId] = useState('');

  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GOGLE_ANALYTICS_KEY || '');
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);

  const goToAddressOrTxId = (addressOrTx: string) => {
    if (addressOrTxId) {
      if (addressOrTxId.length > 42) {
        navigate(`/transactions/${addressOrTx}`);
      } else {
        navigate(`/wallet/${addressOrTx}`);
      }
    }
  };

  const handleSearchKeyPress = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    if (event.key === 'Enter') {
      event.preventDefault();
      goToAddressOrTxId(addressOrTxId);
    }
  };

  return (
    <header>
      <Navbar expand="md">
        <Navbar.Brand>
          <Link to="/">
            <img src={orbLogo} loading="lazy" alt="Orb Explorer" />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarTog">
          <FontAwesomeIcon icon={faBars as IconProp} className="navToggle" />
        </Navbar.Toggle>
        <Navbar.Collapse id="navbarTog">
          <Form className="d-flex">
            <input
              onChange={(event) => setAddressOrTxId(event.target.value)}
              onKeyPress={(event) => handleSearchKeyPress(event)}
              type="search"
              id="search"
              name="search"
              placeholder="Search address or transaction id"
              size={50}
            />
          </Form>
          <Nav className="ms-auto">
            <NavDropdown title="Browse">
              <Link to="/collections" className="navbar-nav-link dropdown-item">
                Collections
              </Link>
              {/* <Link to="/assets" className="navbar-nav-link dropdown-item">
                Assets
              </Link> */}
              <Link to="/transactions" className="navbar-nav-link dropdown-item">
                Transactions
              </Link>
            </NavDropdown>
            {/* <Link to="/about" className="nav-link">
              About
            </Link> */}
            <WalletMenu />
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
}
